import { apiRequest } from "./client";

/** Follow-up drafts (Sprint 5, Part 44): POST /api/follow-ups/draft|scan. */
export const followUpsApi = {
  draft: (payload) =>
    apiRequest("/api/follow-ups/draft", { method: "POST", body: JSON.stringify(payload) }),
  scan: () => apiRequest("/api/follow-ups/scan", { method: "POST" }),
};
